import React, { FC, memo } from 'react';
import { ViewWeb } from '../utils/web-view';
import { CreateSiteForm } from './create-site-form';
import './create-site.scss';
import { SiteList } from './site-list';
import { CreateSiteProvider } from './create-site-context-provider';
import PageContainer from '../page-container/page-container';

export const CreateSitePage: FC = memo(() => {
	return (
		<PageContainer className="pageContainer" requireAuthorization={true}>
			<CreateSiteProvider>
				<ViewWeb className="card">
					<SiteList />
					<CreateSiteForm />
				</ViewWeb>
			</CreateSiteProvider>
		</PageContainer>
	);
});
